import { type ReactNode } from 'react';

import { motion } from 'framer-motion';

interface ScrollingTextProps {
	children: ReactNode;
	speed?: number;
}

export function ScrollingText({ children, speed = 10 }: ScrollingTextProps) {
	return (
		<div className="relative h-full w-full overflow-hidden whitespace-nowrap">
			<motion.div
				className="inline-flex"
				animate={{ x: ['100%', '-100%'] }}
				transition={{
					repeat: Infinity,
					duration: speed,
					ease: 'linear',
				}}
			>
				<span>{children}</span>
			</motion.div>
		</div>
	);
}
